/*!jQuery Ajax Queue - v0.1.2pre - 2013-03-19
 * https://github.com/gnarf37/jquery-ajaxQueue
 * Copyright (c) 2013 Corey Frang; Licensed MIT */
"use strict";
(function ($) {

    // jQuery on an empty object, we are going to use this as our Queue
    var ajaxQueue = $({}),
        CLASS_SERVER_NOT_READY = "server-not-ready",
        CLASS_LONG_AJAX_REQUEST = "long-ajax-request",
        catchStatuses = [
            401, //Unauthorized
            402, //Payment Required
            404, //Not Found - не нужно обрабатывать, так как 404я ошибка вообще говоря никогда не пройдёт сама по себе и у юзера будет заблокирован фотобук
            405, //Not allowed
            407, //Proxy Authentication Required
            408, //Request Timeout
            502, //Bad Gateway
            503, //Service Unavailable
            504, //Gateway Timeout
        ],
        serverIsDown = function (jhr, status, text) {
            if (jhr.status == "timeout" || status == "timeout" || catchStatuses.indexOf(jhr.status) > -1){
                return true;
            }
// Не выводим в таких случаях, так как окно появляется во всяких случаях, связанных с обновлением страницы
//        if (!jhr.readyState && !jhr.status) return true;
            return false;
        },
        request_id = 1,
        long_query_active = {},
        showLongQueryOverlay = function(options){
            long_query_active[options.ajax_queue_id] = true;
            $(".long-ajax-request-text").html(options.longQueryText);
            $("html").addClass(CLASS_LONG_AJAX_REQUEST);
        },
        hideLongQueryOverlay = function(options){
            delete long_query_active[options.ajax_queue_id];
            setTimeout(function(){
                if (!Object.keys(long_query_active).length){
                    $("html").removeClass(CLASS_LONG_AJAX_REQUEST);
                }
            }, 0);
        };

    $.ajaxQueue = function(ajaxOpts){
        if (ajaxOpts === undefined){
            return ajaxQueue.queue();
        }
        var jqXHR,
            dfd = $.Deferred(),
            promise = dfd.promise();

        // run the actual query
        function doRequest(next){
            var options = $.extend(true, {
                    "ajax_queue_id" : request_id++,
                    "headers" : {
                        "AjaxQueue" : 1,
                    },
                }, ajaxOpts);

            jqXHR = $.ajax(options)
            .done(function(response, status, jqXHR){
                hideLongQueryOverlay(options);
                dfd.resolve.call(this, response, status, jqXHR);
            })
            .fail(function (jhr, status, text){
                if (!serverIsDown(jhr, status, text)){
                    return dfd.reject.call(this, jhr, status, text);
                }
            })
            .always(next, function (jhr, status, text){
                if (serverIsDown(jhr, status, text)){
                    $("html").addClass(CLASS_SERVER_NOT_READY);

                    var timeout = 5000,
                        result_fun = function(){
                            $("html").removeClass(CLASS_SERVER_NOT_READY);
                            doRequest(next);
                        },
                        ping_to = 0,
                        ping_fun = function(){
                            $.ajax({
                                "url": "/ping.php",
                                "cache": false,
                                "dataType": "json"
                            }).done(function (ping) {
                                ping_to = setTimeout(ping.ready === 1 ? result_fun : ping_fun, timeout);
                            }).fail(function (j, r, s) {
                                ping_to = setTimeout(ping_fun, timeout);
                            });
                        };

                    ping_to = setTimeout(ping_fun, timeout);
                } else {
                    hideLongQueryOverlay(options);
                    return next.call(this, jhr, status, text);
                }
            });

            if (typeof options.longQueryTimeout == "number"){
                if (options.longQueryTimeout == 0){
                    showLongQueryOverlay(options);
                } else {
                    setTimeout(function(){
                        if (promise.state() == "pending"){
                            showLongQueryOverlay(options);
                        }
                    }, options.longQueryTimeout);
                }
            }
        }

        // queue our ajax request
        ajaxQueue.queue(doRequest);

        // add the abort method
        promise.abort = function (statusText) {

            // proxy abort to the jqXHR if it is active
            if (jqXHR) {
                return jqXHR.abort(statusText);
            }

            // if there wasn't already a jqXHR we need to remove from queue
            var queue = ajaxQueue.queue(),
                index = $.inArray(doRequest, queue);

            if (index > -1) {
                queue.splice(index, 1);
            }

            // and then reject the deferred
            dfd.rejectWith(ajaxOpts.context || ajaxOpts, [promise, statusText, ""]);
            return promise;
        };
        return promise;
    };

})(jQuery);